import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CHAPTERS } from "./data";
import { Eyebrow, MaskLines, Reveal } from "./motion";

const Chapter = ({ c }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "center 45%"] });
  const fill = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  return (
    <article ref={ref} className="grid md:grid-cols-12 gap-6 md:gap-10 py-14 md:py-20 border-t border-white/10" data-testid={`manifesto-chapter-${c.n}`}>
      <div className="md:col-span-4 relative">
        <span className="font-mono text-[11px] tracking-[0.3em] text-slate-500 uppercase">Chapter</span>
        <div className="relative font-display font-black leading-none text-[7rem] sm:text-[9rem] lg:text-[11rem] tracking-tighter">
          <span className="text-outline-dim">{c.n}</span>
          <motion.span className="absolute inset-0 text-cyan-300 overflow-hidden" style={{ clipPath: useTransform(fill, (f) => `inset(${100 - parseFloat(f)}% 0 0 0)`) }}>
            {c.n}
          </motion.span>
        </div>
      </div>
      <div className="md:col-span-8 md:pt-10">
        <h3 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] max-w-3xl">
          <MaskLines lines={[c.title]} />
        </h3>
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-slate-400 leading-relaxed">{c.body}</p>
        </Reveal>
      </div>
    </article>
  );
};

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 md:py-36" data-testid="manifesto-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10 mb-12 md:mb-20">
        <div className="md:col-span-4"><Eyebrow>The Lunar method</Eyebrow></div>
        <h2 className="md:col-span-8 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.08]">
          <MaskLines lines={["Enterprise experience,", <span className="font-serif-i font-normal text-slate-400">small-business focus.</span>]} />
        </h2>
      </div>
      {CHAPTERS.map((c) => <Chapter key={c.n} c={c} />)}
    </div>
  </section>
);
